/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { connect } from 'react-redux';

import store from 'features/store';

// style imports
import './Footer.scss';

import { ADSENSE, SellWithUsLink } from 'shared/settings/config';
import { addDataLayer } from 'shared/utils/utils';
import { Adsense } from 'shared/utils/Adsense';
import moment from 'moment-timezone';
import { NavigationBarHOC } from 'shared/hoc/navigation/NavigationBarHOC';
import { facebook, instagram, linkedIn, twitterX } from 'shared/assets/icons';

/**
 * defines footer when needed is made
 * 
 * @param props
 * 
 * @returns html to render footer message if available after login
 * 
**/

export class Footer extends Component {

    constructor(props) {
        super(props);
        
        this.pathname = props?.history?.location?.pathname;
    }
    navigate = (flag) => {
        this.props.history.push(`/${flag}`);
    }

    openModals = (type, payload = true) => {
        store.dispatch({ type: type, payload: payload });
    }

    openCaringTransitions = () => {
        window.open('https://www.caringtransitions.com/', '_blank');
    }

    openInNewTab = (link) => {
        window.open(link, '_blank');
        let dataLayerData = {
            'event': 'scmlink_clicks',
            'title': link
        }
        addDataLayer(dataLayerData); 
    }

    sellWithUs = () => {
        window.open(SellWithUsLink, '_blank');
        let dataLayerData = {
            'event': 'sell_with_us'
        }
        addDataLayer(dataLayerData); 
    }
    render() {
        return (
            <div className={`footer-container ${this.props.className ? this.props.className : ''}`}>
                {this.props.match.path == '/' ?
                    <div className="d-flex flex-column align-items-center footer-about-us ">
                        <div className="mb-4 header-about-us mt-5" style={{ color: '#00263E' }}>What People Are Saying About Us</div>
                       
                        <div style={{ padding: '20px', marginBottom: '4%' }}>
                            <div className='review-section' >
                                <div className='left-side-content'>
                                    <span style={{ fontWeight: '700', color: '#A50050' }}>Caring Transitions of Mankato</span>   <br /><br />

                                </div>
                                <div className='right-side-content'>
                                    <span style={{ fontWeight: 'bold', color: '#A50050' }}>Caring Transitions of Twin Cities Central</span> <br /> <br />

                                </div>

                            </div>
                            <div className='review-section'>
                                <div className='left-side-content'>
                                    <div style={{width:'95%' }}>
                                    Doug is really fun to work with and is just a genuine nice person. He has the perfect personality for this business.
                                    I have participated in the online auctions for CTBids in the past to purchase furniture and items for my son who now moving away.
                                    I found great quality items and was able to get most of the things we needed at a very reasonable price.
                                    I always head over to his auctions when needing things for our home.
                                    The bidding process was easy and the pick-up of our items went very smooth. Thanks for all the help.
                                    </div>

                                </div>
                                <div className='right-side-content'>
                                    <div  style={{width:'95%' }}>
                                        
                                    Love this company! Great communications with the buyer! I always know exactly where my item is in the process of shipping.
                                    They team up with a super local shipping company that have handled all of my items with extreme care - and applied reasonable shipping rates.
                                    I really enjoy bidding on this CT Bids site. I know the items are in good hands! Thank you!

                                    </div>

                                </div>

                            </div>
                            <div className='review-section mb-3' style={{ marginTop: '10px'}}>
                                <div className='left-side-content'>
                                    <span style={{ color: '#A50050' }}>Kara P</span>

                                </div>
                                <div className='right-side-content'>
                                    <span className='mt-3' style={{ color: '#A50050' }}>Lucinda S</span>
                                </div>

                            </div>
                        </div>
                    </div>
                     : ''}
                
                { this.props.match.path == '/' && ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.FOOTER.slotId}/> : '' }
                
                <div className="d-flex flex-column align-items-center justify-content-center footer-main">
                    <div className="links-container set-margin">
                        <div className="link" onClick={() => { this.navigate('advance-search'); }}>Search</div>
                        <div className="splitter"></div><div className="link" onClick={() => { this.navigate('estate-sale/list'); }}>Estate Sales</div>
                        <div className="splitter"></div><div className="link" onClick={() => { this.navigate('locations'); }}>Locations</div>
                        <div className="splitter"></div><div className="link" onClick={() => { this.navigate('ourstory'); }}>Our Story</div>
                        <div className="splitter"></div>
                        {
                            this.props.user.membershipCompleted ? <div className="link" onClick={() => { this.navigate(this.props?.user?.membershipCompleted ? "my-account/premier/member-benefits" : 'premier-membership') }}>{this.props?.user?.membershipCompleted ? "Your Premier Membership" : 'Premier Membership'}</div> :
                                <div className="link" onClick={() => { this.navigate('help/faq') }}>FAQ</div>
                        }
                        <div className="splitter"></div><div className="term link" onClick={() => { window.open("https://assets.ctbids.com/buyer/CTBidsTermsandConditions1.10.25.pdf", "_blank"); }}>Terms &amp; Conditions</div>
                        <div className="splitter"></div><div className="policy link" onClick={() => { this.navigate('privacy'); }}>Privacy Policy</div>
                    </div>
                    <div className="image-container">
                        <div className="image" style={{ marginRight: '2px' }}>
                            <img src={`${process.env.PUBLIC_URL}/static/footer/Facebook_svg.svg`} alt="Facebook" className="clickable"
                                onClick={() => this.openInNewTab('https://www.facebook.com/CTBidsOnlineAuctions/')}></img>
                        </div>
                        <div className="image" >
                            <img src={`${process.env.PUBLIC_URL}/static/footer/Instagram_svg.svg`} alt="Instagram" className="clickable"
                                onClick={() => this.openInNewTab('https://www.instagram.com/ctbids/')} style={{marginTop: '2px'}}></img>
                        </div>
                        <div className="image">
                            <img src={`${process.env.PUBLIC_URL}/static/footer/linkedin_svg.svg`} alt="Linkedin" className="clickable"
                                onClick={() => this.openInNewTab('https://www.linkedin.com/showcase/ctbids/')}></img>
                        </div>
                        <div className="image">
                            <img src={`${process.env.PUBLIC_URL}/static/footer/X_svg.svg`} alt="Twitter" className="clickable" style={{ width: '26px', marginTop: '5px'}}
                                onClick={() => this.openInNewTab('https://twitter.com/CTBids_')}></img>
                        </div>
                    </div>
                    <hr style={{ backgroundColor: "#D0DF00", color: "#D0DF00", height: "2px", width: "65%" }}></hr>
                    <div className="copy-right-content pb-30">
                        Copyright © {moment().format('YYYY')} C.T. Franchising Systems, Inc. dba Caring Transitions. All Rights Reserved. No part of this web page may
                        be reproduced in any way, or by any means, without the prior written permission of C.T. Franchising Systems, Inc.
                    </div>
                    <div className="copy-right-content">
                        Each Caring Transitions<sup> &reg;</sup> location is independently owned and operated.
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => state)(Footer);

const footerTopMenus = [
    { id: 1, label: 'News and Stories', type: 'link', redirectTo:  '/stories', active: false },
    { id: 2, label: 'Locations', type: 'link', redirectTo: '/locations', active: false },
    { id: 3, label: 'Our Story', type: 'link', redirectTo: '/ourstory', active: false },
    { id: 4, label: 'FAQ', type: 'link', redirectTo: '/help/faq', active: false },
    { id: 5, label: 'Terms & Conditions', type: 'external-link', redirectTo: '', openUrl: "https://assets.ctbids.com/buyer/CTBidsTermsandConditions1.10.25.pdf", active: false },
    { id: 6, label: 'Privacy Policy', type: 'link', redirectTo: '/privacy', active: false },
];

const footerMiddleMenus = [
    { id: 7, label: 'Sell with Us', type: 'link',  type: 'external-link', redirectTo: '', openUrl: "https://www.caringtransitions.com/two-ways-to-sell", active: false },
    // { label: 'Become our Caring Partner', type: 'link', redirectTo: '', active: false },
    { id: 8, label: 'Know more about Caring Transitions', type: 'link',  type: 'external-link', redirectTo: '', openUrl: "https://www.caringtransitions.com/", active: false },
];

export const FooterNew = (props) => {

    const openInNewTab = (link) => {
        window.open(link, '_blank');

        let dataLayerData = {
            'event': 'scmlink_clicks',
            'title': link
        }
        addDataLayer(dataLayerData); 
    }

    return (
        <div className='footer-box'>
            <div className='footer-top-box'>
                <div className='logo-box'>
                    <img onClick={()=> props.history.push('/')} src={`${process.env.PUBLIC_URL}/static/logo/CTBids_logo.png`} alt="CTBids home logo" className="logo-image clickable" />
                </div>
                
                <NavigationBarHOC props={props} menus={footerTopMenus} menuStyling={{fontWeight: 'normal', backgroundColor: 'transparent'}} />
                
                <div className='social-media-box'>
                    <div className='social-media' onClick={() => { openInNewTab('https://www.facebook.com/CTBidsOnlineAuctions/'); }}>{facebook}</div>
                    <div className='social-media' onClick={() => { openInNewTab('https://www.instagram.com/ctbids/'); }}>{instagram}</div>
                    <div className='social-media' onClick={() => { openInNewTab('https://www.linkedin.com/showcase/ctbids/'); }}>{linkedIn}</div>
                    <div className='social-media' onClick={() => { openInNewTab('https://twitter.com/CTBids_'); }}>{twitterX}</div>
                </div>
            </div>
            <div className='footer-middle-box'>
                <NavigationBarHOC props={props} menus={footerMiddleMenus} menuStyling={{fontWeight: 'normal', color: "#ffffff", backgroundColor: 'transparent'}} />
            </div>
            <div className='footer-bottom-box'>
                <div className='text-center copy-right'>Copyright © 2025 C.T. Franchising Systems, Inc. dba Caring Transitions. All Rights Reserved. No part of this web page may be reproduced in any way, or by any means, without the prior written permission of C.T. Franchising Systems, Inc.</div>
                <div>Each Caring Transitions ® location is independently owned and operated.</div>
            </div>
        </div>
    )
};